export default "__VITE_ASSET__BWV1cmF0__"